import type { ReactNode } from "react";
import { BackupScene, DatabaseScene, DomainsScene, EmailScene, KubernetesScene, MaintenanceScene, ProtectionScene, SslScene, StorageScene, VpnScene } from "./hero-art-more";
import { AppsScene, InfraScene, NetworkScene, WebScene } from "./hero-art-scenes";
import type { HERO_PAGES } from "./hero-pages";

/** The isometric drawing of each hero page (server component: the client hero receives them as ready elements). */
export const HERO_ART: Record<(typeof HERO_PAGES)[number], ReactNode> = {
  infra: <InfraScene />, network: <NetworkScene />, apps: <AppsScene />, web: <WebScene />,
  vpn: <VpnScene />, backup: <BackupScene />, domains: <DomainsScene />, email: <EmailScene />, ssl: <SslScene />,
  kubernetes: <KubernetesScene />, storage: <StorageScene />, database: <DatabaseScene />, protection: <ProtectionScene />, maintenance: <MaintenanceScene />,
};
